/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.MigrationChirpService
 */

export const getCatalogResourceMigrationLogRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.MigrationChirpService',
  rpcName: 'getCatalogResourceMigrationLog',
  auth: 'external',
  fingerprint: 'v40gWe7WuuY79r75zchuo_Hm1R_YUwdH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getNewLessonContentMappingByOldMappingAndLanguageRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.MigrationChirpService',
  rpcName: 'getNewLessonContentMappingByOldMappingAndLanguage',
  auth: 'external',
  fingerprint: '-nG2HnhPMHS9WoQYaFDs4PHm1R_YUwdH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};